/**
 * Table of Contents (TOC) Generator and ScrollSpy
 */

document.addEventListener('DOMContentLoaded', () => {
    const contentArea = document.querySelector('.entry-content');
    const tocContainers = document.querySelectorAll('.toc');
    
    if (!contentArea || tocContainers.length === 0) return;

    // 1. Find the headings (h2 and h3 only)
    const headings = contentArea.querySelectorAll('h2, h3');
    if (headings.length === 0) {
        // Hide TOC containers if no headings found
        document.querySelectorAll('.toc-container').forEach(el => el.style.display = 'none');
        return;
    }

    // 2. Generate IDs and Build TOC Data
    const tocData = [];
    let currentH2 = null;

    headings.forEach((heading, index) => {
        // Ensure the heading has a unique ID
        if (!heading.id) {
            const slug = heading.textContent
                .toLowerCase()
                .replace(/[^\w\s-]/g, '')
                .replace(/\s+/g, '-');
            heading.id = slug || `heading-${index}`;
        }

        const item = {
            id: heading.id,
            text: heading.textContent,
            level: heading.tagName.toLowerCase(),
            children: []
        };

        if (item.level === 'h2') {
            tocData.push(item);
            currentH2 = item;
        } else if (item.level === 'h3') {
            if (currentH2) {
                currentH2.children.push(item);
            } else {
                // If an h3 comes before any h2, treat it as a top-level item
                tocData.push(item);
            }
        }
    });

    // 3. Build HTML for TOC
    const buildTOCMarkup = (data) => {
        if (!data.length) return '';
        let html = '<ul>';
        data.forEach(item => {
            html += `<li><a href="#${item.id}" data-target="${item.id}">${item.text}</a>`;
            if (item.children && item.children.length > 0) {
                html += buildTOCMarkup(item.children);
            }
            html += '</li>';
        });
        html += '</ul>';
        return html;
    };

    const tocMarkup = buildTOCMarkup(tocData);
    tocContainers.forEach(container => {
        container.innerHTML = tocMarkup;
    });

    // 4. Smooth Scrolling for TOC links
    const tocLinks = document.querySelectorAll('.toc a');
    tocLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            const targetId = link.getAttribute('data-target');
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                const headerOffset = 100; // Adjust for fixed header
                
                if (window.lenis) {
                    // Use Lenis for smooth scrolling if available
                    window.lenis.scrollTo(targetElement, {
                        offset: -headerOffset,
                        duration: 1.2,
                        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
                    });
                } else {
                    // Fallback to native smooth scroll
                    const elementPosition = targetElement.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                }

                // Update URL hash without jumping
                history.pushState(null, null, `#${targetId}`);
            }
        });
    });

    // 5. ScrollSpy (Intersection Observer)
    const observerOptions = {
        root: null,
        rootMargin: '-100px 0px -70% 0px', // High top margin to trigger as it enters the "reading zone"
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        // Disable scroll position observer if the screen size is below 992px
        if (window.innerWidth < 992) return;

        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute('id');
                
                // Remove active class from all links
                tocLinks.forEach(link => {
                    link.classList.remove('active');
                    if (link.getAttribute('href') === `#${id}`) {
                        link.classList.add('active');
                        
                        // If it's a child (h3), also make the parent (h2) active or highlighted? 
                        // Usually just the current one is enough.
                    }
                });
            }
        });
    }, observerOptions);

    headings.forEach(heading => observer.observe(heading));
});
